import {
    EdgeLabelRenderer,
    BaseEdge,
    getSmoothStepPath,
  } from "@xyflow/react";

  const LABEL_OFFSET_FROM_SOURCE = 48;

  export function CustomEdge(props) {
    const {
      id,
      sourceX,
      sourceY,
      targetX,
      targetY,
      sourcePosition,
      targetPosition,
      data,
    } = props;

    const [edgePath] = getSmoothStepPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });

    return (
      <>
        <BaseEdge id={id} path={edgePath} />
        <EdgeLabelRenderer>
          <div className="nodrag nopan">
            <div
              className="absolute pointer-events-auto"
              style={{
                transform: `translate(-50%, -50%) translate(${targetX}px, ${
                  sourceY + LABEL_OFFSET_FROM_SOURCE
                }px)`,
              }}
            >
              {data?.sourcePort}
            </div>
          </div>
        </EdgeLabelRenderer>
      </>
    );
  }